import { render, staticRenderFns } from "./BrokerFirmOrderTable.vue?vue&type=template&id=04c32cea&scoped=true"
import script from "./BrokerFirmOrderTable.vue?vue&type=script&lang=js"
export * from "./BrokerFirmOrderTable.vue?vue&type=script&lang=js"
import style0 from "./BrokerFirmOrderTable.vue?vue&type=style&index=0&id=04c32cea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c32cea",
  null
  
)

export default component.exports